import { View } from "../../../../../core/view/index";
import { LazyTemplate, Template } from "../../../../../core/template/index";
import BBrowser from "../../../../../core/bbclient/browser";
import MessageModal from "..././../../core/modals/message/index";
import { FortumApp } from "../../../../fortumApp";
import { clamp } from "../../../../../core/helpers/math";
import { Address } from "../../../../../core/db/models/index";
import { Order, OrderLike } from "../../../../db/models/decontamination/order";
import { OrderBaseView, OrderBaseViewData } from "../base";
import Listbox, { ListboxSelectType } from "../../../../../core/component/listbox/index";
import ListboxItem, { ListboxItemViewData } from "../../../../../core/component/listbox/item";
import OrderItemFlipcardView from "../../orderItem/flipcard/index";
import TabControlView from "../../../../../core/views/tabControl/index";
import OrderDetailTabView from "../tab/detail/index";
import OrderOverviewTabView from "../tab/overview/index";
import { OrderItemLike, OrderItem } from "../../../../db/models/decontamination/orderItem";
import OrderPhotographingTabView from "../tab/photographing/index";
import OrderItemsTabView from "../tab/items";

export default class OrderDetailView extends OrderBaseView
{
    public template = Template.lazy('/app/views/decontamination/order/detail/index.html');
    private orderItemContainer: HTMLDivElement;
    public app: FortumApp;
    private topView: HTMLDivElement;
    public data: OrderDetailViewData;
    private orderItemViews: OrderItemFlipcardView[];
    private wrapper: HTMLElement;
    private tabControl: TabControlView;
    private detailView: OrderDetailTabView;
    private itemsView: OrderItemsTabView;
    private photographingView: OrderPhotographingTabView;
    private overviewView: OrderOverviewTabView;
    
    private resolveActiveTabPage()
    {
        if (this.data.tab == null)
        {
            return 'detail';
        }

        return this.data.tab;
    }

    private validate()
    {
        this.data.isValid = this.data.order.items.find(o => o.state != OrderItem.STATE_COMPLETED) == null;
        this.data.validatedItems = [];
        this.data.isCompleted = this.data.order.state == Order.STATE_COMPLETED;

        for(let orderItem of this.data.order.items)
        {
            this.data.validatedItems.push({
                item: orderItem,
                isValid: orderItem.state == OrderItem.STATE_COMPLETED
            });
        }
    }

    public beforeRender(): PromiseLike<void>
    {
        return super.beforeRender().then(() =>
        {
            this.app.header.text = this.pgettext('decontamination.Order.title', 'Decontamination record {ext_id}', {
                ext_id: this.data.order.ext_id
            });
            let viewRenders: PromiseLike<any>[] = [];
            this.orderItemViews = [];
            this.validate();

            // let sortedOrderItems = this.data.order.items.slice(0).sort((a, b) => orderItem.STATE_SORT[a.state] <orderItem.STATE_SORT[b.state] ? 0 : 1);
            for(let orderItem of this.data.order.items)
            {
                let view = new OrderItemFlipcardView(orderItem);
                viewRenders.push(this.app.renderPartialView(view));
                this.orderItemViews.push(view);
            }
            
            this.tabControl = new TabControlView({
                activePage: this.resolveActiveTabPage(),
                tabPageClassNames: 'order',
                pages: [
                    {title: this.pgettext('decontamination.Order.tab.title', 'Details'), id: 'detail'},
                    {title: this.pgettext('decontamination.Order.tab.title', 'Items'), id: 'items', classNames: ''},
                    {title: this.pgettext('decontamination.Order.tab.title', 'Photographing'), id: 'photographing', classNames: ''},
                    {title: this.pgettext('decontamination.Order.tab.title', 'Overview'), id: 'overview', classNames: ''},
                ]
            });

            this.detailView = new OrderDetailTabView(this.data);
            this.itemsView = new OrderItemsTabView(this.data);
            this.photographingView = new OrderPhotographingTabView(this.data);
            this.overviewView = new OrderOverviewTabView(this.data);

            viewRenders.push(this.app.renderPartialView(this.detailView));
            viewRenders.push(this.app.renderPartialView(this.itemsView));
            viewRenders.push(this.app.renderPartialView(this.tabControl));
            viewRenders.push(this.app.renderPartialView(this.photographingView));
            viewRenders.push(this.app.renderPartialView(this.overviewView));
            
            return <PromiseLike<void>>Promise.all(viewRenders).then(() => {});
        });
    }

    public afterRender(): PromiseLike<void>
    {        
        this.tabControl.getPage('detail').appendChild(this.detailView.element);
        this.tabControl.getPage('photographing').appendChild(this.photographingView.element);
        this.tabControl.getPage('overview').appendChild(this.overviewView.element);
        this.tabControl.getPage('items').appendChild(this.itemsView.element);

        for(let itemView of this.orderItemViews)
        {
            this.itemsView.container.appendChild(itemView.element);
        }  

        this.wrapper.appendChild(this.tabControl.element);
        return super.afterRender();
    }

    private onExitOrderButtonClick(e: MouseEvent, sender: HTMLButtonElement)
    {
        location.hash = '#/';
    }
}

export interface validatedItem
{
    item: OrderItemLike;
    isValid: boolean;
}

export interface OrderDetailViewData extends OrderBaseViewData
{
    isCompleted?: boolean;
    isValid?: boolean;
    tab?: string;
    validatedItems?: validatedItem[];
}